import { buildComponent } from '#components'

import './password.css'

export const PasswordForm = buildComponent({
  name: 'password-form',
  onConnected: (component) => {
    const correctPassword = component.dataset.password

    const input = component.querySelector('.js-password-protect') as HTMLInputElement
    const submitBtn = component.querySelector('.js-submit-password-protect') as HTMLButtonElement
    const wrongMsg = component.querySelector('.js-wrong-password-protect') as HTMLElement
    const overlay = component.querySelector('.js-password-overlay') as HTMLElement
    const passwordForm = document.querySelector('.js-password-form') as HTMLElement
    const contactFormWrapper = document.querySelector('.js-contact-form-protect') as HTMLElement

    const showContactForm = () => {
      if (overlay) overlay.classList.add('tw-hidden')

      if (contactFormWrapper) {
        contactFormWrapper.classList.remove('tw-hidden')
      }

      if (passwordForm) {
        passwordForm.classList.remove('tw-block')
        passwordForm.classList.add('tw-hidden')
      }
    }

    const url = new URL(window.location.href)

    if (url.searchParams.get('form_type') === 'contact') {
      showContactForm()
      document.body.classList.add('contact-form-submitted')

      const successMessage = document.querySelector('.successMessage')

      if (successMessage) {
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }

      url.search = ''
      url.hash = '#contact_form'
      window.history.replaceState({}, document.title, url.toString())

      return
    }

    const handleSubmit = () => {
      if (input?.value === correctPassword) {
        showContactForm()
      } else {
        if (wrongMsg) wrongMsg.classList.remove('tw-hidden')
      }
    }

    submitBtn?.addEventListener('click', handleSubmit)

    input?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        handleSubmit()
      }
    })
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'password-form': typeof PasswordForm
  }
}
